//Plantilla de archivo de store
const namespaced = true
import api from '../../../api/catalogs/structure.js';

const state = {
    operative_structure: [],
    loading_struct: false,

    filterd_areas: [],
    filterd_sub_areas: [],
    filtered_lines: [],

    selected_areas: [],
    selected_areas_sub: [],
    selected_lines: [],
    selected_equipment: [],
    selected_component: [],
    selected_failure: [],
}
const mutations = {
    SET_STRUCTURE(state, data) {
        state.operative_structure = data;
    },
    SET_LOADING_STRUCTURE(state, data) {
        state.loading_struct = data;
    },
    //#######################################################################################################################################
    //Funciones para el modulo de OPERATIVE STRUCTURE
    //#######################################################################################################################################
    ADD_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.unshift(value);
    },
    UPDATE_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.id).name = value.name;
        //Esto acualiza toda la estructura de la sub area
        // const plant = state.operative_structure.find(item => item.id === value.plant_id);
        // const area = plant.production_areas.find(item => item.id === value.id);
        // Object.assign(area, value);
    },
    DESACTIVATE_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.id).active = value.active;
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.id).areaShow = value.areaShow;
    },
    ACTIVATE_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.id).active = value.active;
    },
    ADD_SUB_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.unshift(value);
    },
    UPDATE_SUB_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.id).name = value.name
    },
    DESACTIVATE_SUB_PRODUCTION_AREA(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.id).active = value.active
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.id).subAreaShow = value.subAreaShow
    },
    ADD_PRODUCTION_LINE(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.sub_area_id).production_lines.unshift(value);
    },
    UPDATE_PRODUCTION_LINE(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.sub_area_id).production_lines.find(item => item.id === value.id).name = value.name;
    },
    DESACTIVATE_PRODUCTION_LINE(state, value) {
        state.operative_structure.find(item => item.id === value.plant_id).production_areas.find(item => item.id === value.production_area_id).sub_production_areas.find(item => item.id === value.sub_area_id).production_lines.find(item => item.id === value.id).active = value.active;
    },
    //#######################################################################################################################################
    //Funciones para el modulo de delayEvent
    //#######################################################################################################################################
    FILTER_PRODUCTION_AREA(state, value) {
        const areas = state.operative_structure
            .filter(plant => value.includes(plant.id)) // 1. filtra plantas
            .flatMap(plant => plant.production_areas || []); // 2. extrae áreas
        // const filtereAreas = areas.map(p => ({
        //         id: p.id,
        //         name: p.name
        //     }));
        // state.filterd_areas = filtereAreas;
        state.filterd_areas = areas;
    },
    FILTER_SUB_PRODUCTION_AREA(state, value) {
        const subAreas = state.filterd_areas.filter(area => value.includes(area.id)).flatMap(area => area.sub_production_areas || []);
        state.filterd_sub_areas = subAreas;
    },
    FILTER_PRODUCTION_LINES(state, value) {
        const prodLines = state.filterd_sub_areas.filter(subArea => value.includes(subArea.id)).flatMap(subArea => subArea.production_lines || []);
        state.filtered_lines = prodLines;
    },
    //#######################################################################################################################################
    //Funciones para el modulo de delayEvent
    //#######################################################################################################################################
    SELECT_AREA(state, value){
        (value) ? state.selected_areas = state.operative_structure.find(item => item.id === value).production_areas : state.selected_areas = [];
    },
    SELECT_SUB_AREA(state, value){
        (value) ? state.selected_areas_sub = state.selected_areas.find(item => item.id === value).sub_production_areas : state.selected_areas_sub = [];
    },
    SELECT_LINE_PROD(state, value){
        (value) ? state.selected_lines = state.selected_areas_sub.find(item => item.id === value).production_lines : state.selected_lines = [];
    },
    SELECT_EQUIPMENT(state, value){
        (value) ? state.selected_equipment = state.selected_lines.find(item => item.id === value).equipments : state.selected_equipment = [];
    },
    SELECT_COMPONENT(state, value){
        (value) ? state.selected_component = state.selected_equipment.find(item => item.id === value).componentes : state.selected_component = [];
        (value) ? state.selected_failure = state.selected_equipment.find(item => item.id === value).failures : state.selected_failure = [];
    },
}


const actions = {
    getStructure(context, data) {
        context.commit('SET_LOADING_STRUCTURE', true);
        return new Promise((resolve) => {
            api.getStructure(data).then(function (res) {
                context.commit('SET_STRUCTURE', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_STRUCTURE', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_STRUCTURE', false);
            })
        })
    },
    //#######################################################################################################################################
    //Funciones para el modulo de OPERATIVE STRUCTURE
    //#######################################################################################################################################
    addAreaToStructure(context, data) {
        context.commit('ADD_PRODUCTION_AREA', data);
    },
    updateAreaToStructure(context, data) {
        context.commit('UPDATE_PRODUCTION_AREA', data);
    },
    desactivateAreaToStructure(context, data) {
        context.commit('DESACTIVATE_PRODUCTION_AREA', data);
    },
    activateAreaToStructure(context, data) {
        context.commit('ACTIVATE_PRODUCTION_AREA', data);
    },
    addSubAreaToStructure(context, data) {
        context.commit('ADD_SUB_PRODUCTION_AREA', data);
    },
    updateSubAreaToStructure(context, data) {
        context.commit('UPDATE_SUB_PRODUCTION_AREA', data);
    },
    desactivateSubAreaToStructure(context, data) {
        context.commit('DESACTIVATE_SUB_PRODUCTION_AREA', data);
    },
    addLineToStructure(context, data) {
        context.commit('ADD_PRODUCTION_LINE', data);
    },
    updateLineToStructure(context, data) {
        context.commit('UPDATE_PRODUCTION_LINE', data);
    },
    desactivateLineToStructure(context, data) {
        context.commit('DESACTIVATE_PRODUCTION_LINE', data);
    },
    //#######################################################################################################################################
    //Funciones para el modulo de delayEvent
    //#######################################################################################################################################
    filterProductionArea(context, data) {
        context.commit('FILTER_PRODUCTION_AREA', data);
    },
    filterSubProductionArea(context, data) {
        context.commit('FILTER_SUB_PRODUCTION_AREA', data);
    },
    filterProductionLines(context, data) {
        context.commit('FILTER_PRODUCTION_LINES', data);
    },
    //#######################################################################################################################################
    //Funciones para el modulo de agregar demora
    //#######################################################################################################################################
    selectedOneArea(context, data){
        context.commit('SELECT_AREA', data);
    },
    selectedOneSubArea(context, data){
        context.commit('SELECT_SUB_AREA', data);
    },
    selectedOneLine(context, data){
        context.commit('SELECT_LINE_PROD', data);
    },
    selectOneEquipment(context, data){
        context.commit('SELECT_EQUIPMENT', data);
    },
    selectOneComponent(context, data){
        context.commit('SELECT_COMPONENT', data);
    },
}
const getters = {
    getOperativeStructure(state) {
        return state.operative_structure;
    },
    //#######################################################################################################################################
    //getters para el modulo de delayEvent
    //#######################################################################################################################################
    getFilterdAreas(state) {
        return state.filterd_areas;
    },
    getFilterdSubAreas(state) {
        return state.filterd_sub_areas;
    },
    getFilterdProductionLines(state) {
        return state.filtered_lines;
    },
    //#######################################################################################################################################
    //getters para el modulo de agregar demora
    //#######################################################################################################################################
    getSelectedAreas(state) {
        return state.selected_areas;
    },
    getSelectedSubAreas(state){
        return state.selected_areas_sub;
    },
    getSelectedLinesProd(state){
        return state.selected_lines;
    },
    getSelectedEquipments(state){
        return state.selected_equipment;
    },
    getSelectedComponents(state){
        return state.selected_component;
    },
    getSelectedFailures(state){
        return state.selected_failure;
    },
    
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}